import React, {Component} from "react"
import {Row} from "react-bootstrap"

import {FormattedMessage} from "@irati/utils/lang"
import {ValidationProps} from "@irati/utils/validation/Input"

import ErrorText from "../ErrorText"
import Input from "../FormItem/Input"

import {AddButton, RemoveButton, RowRelative} from "./styled"

interface Props extends ValidationProps<string> {
  update: (inputs: string[]) => void,
  inputs: string[],
  label: string,
  addButtonText: string
}

interface State {
  inputs: string[],
  maximumReached: boolean
}

class AddRemoveInputList extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      inputs: props.inputs,
      maximumReached: false
    }
  }

  update = () => {
    this.props.update(this.state.inputs)
  }

  addInput = () => {
    this.setState((state) => {
      let inputs = state.inputs
      let maximumReached = true

      if (inputs.length <= 15) {
        inputs = [...inputs, ""]
        maximumReached = false
      } else {
        setTimeout(() => this.setState({maximumReached: false}), 3000)
      }
      return {inputs, maximumReached}
    }, this.update)
  }

  onChangeInput = (valueToUpdate: string, indexToChange: number) => {
    this.setState(
      (state) => ({
        inputs: state.inputs.map((value, index) => {
          if (indexToChange === index) {
            return valueToUpdate
          }
          return value
        })
      }),
      this.update
    )
  }

  removeInput = (indexToRemove: number) => {
    this.setState(
      (state) => ({
        inputs: state.inputs.filter((_, index) => index !== indexToRemove),
        maximumReached: false
      }),
      this.update
    )
  }

  render() {
    const {label, validation, addButtonText} = this.props
    const {inputs, maximumReached} = this.state
    return (
      <>
        <Row>
          <Input
            name="addRemoveInput"
            label={label}
            onChange={(value: string) => this.onChangeInput(value, 0)}
            value={inputs[0]}
            validation={validation} />
        </Row>
        {inputs.slice(1, inputs.length).map((value, index) => (
          <RowRelative key={index + 1}>
            <Input
              name="addRemoveInput"
              label={label}
              value={value}
              onChange={(newValue: string) => this.onChangeInput(newValue, index + 1)}
              validation={validation} />
            <RemoveButton onClick={() => this.removeInput(index + 1)}>
              <FormattedMessage id="admin.components.emailDomain.addRemoveInputList.removeButton.text" />
            </RemoveButton>
          </RowRelative>
        ))}
        <AddButton full small onClick={this.addInput}>
          {addButtonText}
        </AddButton>
        {maximumReached && (
          <ErrorText>
            <FormattedMessage id="admin.components.emailDomain.addRemoveInputList.errorText" />
          </ErrorText>
        )}
      </>
    )
  }
}

export default AddRemoveInputList
